/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountsPayableCountRequest,
  AccountsPayableCountResponse,
  AccountsPayableCsvRequest,
  AccountsPayableGetAllQuery,
  AccountsPayablePaginationQuery,
  AccountsPayablePaymentDetailsDto,
  AccountsPayablePaymentExecutionDetailsDto,
  AccountsPayableSepaPaymentPreviewSummaryDto,
  AccountsPayableSummaryQuery,
  AccountsPayableSummaryResponse,
  AuthoriseAccountsPayableWithIdsRequest,
  BatchPreparePaymentsResponse,
  DownloadPaymentOrderConfirmationAccountsPayableRequestWithIdRequest,
  DownloadSepaFileAccountsPayableWithIdsRequest,
  EditPaymentReferenceAccountsPayableWithNoIdentifierRequest,
  GetAllAccountsPayableResponse,
  GetByLinkedFlowParams,
  GetListByIdsParams,
  GetListByLinkedFlowsParams,
  InProgressAccountsPayableDetailsResponse,
  MarkAsNotPaidAccountsPayableWithIdsRequest,
  MarkAsPaidAccountsPayableWithIdsRequest,
  PageAccountsPayablePaymentDetailsDto,
  PreviewSepaFileAccountsPayableWithIdsRequest,
  RevokeAuthorizationAccountsPayableRequestWithIds,
  WalletPaymentExecutionDetailsRequest,
  WalletPaymentsPrepareRequestWithIds,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPaymentDetailsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name DownloadAccountsPayableCustomCsv
   * @request POST:/api/v1/payment-details/csv/templates/{templateId}
   */
  downloadAccountsPayableCustomCsv = (
    templateId: string,
    data: AccountsPayableCsvRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/payment-details/csv/templates/${templateId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadAccountsPayableCustomCsvPath = '/v1/payment-details/csv/templates/${templateId}'
  static downloadAccountsPayableCustomCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetSummary
   * @request POST:/api/v1/payment-details/accounts-payable/summary
   */
  getSummary = (data: AccountsPayableSummaryQuery, params: RequestParams = {}) =>
    this.http.request<AccountsPayableSummaryResponse, any>({
      path: `/v1/payment-details/accounts-payable/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSummaryPath = '/v1/payment-details/accounts-payable/summary'
  static getSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetAccountsPayableSepaPaymentPreviewSummary
   * @request POST:/api/v1/payment-details/accounts-payable/sepa/preview
   */
  getAccountsPayableSepaPaymentPreviewSummary = (
    data: PreviewSepaFileAccountsPayableWithIdsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountsPayableSepaPaymentPreviewSummaryDto, any>({
      path: `/v1/payment-details/accounts-payable/sepa/preview`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAccountsPayableSepaPaymentPreviewSummaryPath =
    '/v1/payment-details/accounts-payable/sepa/preview'
  static getAccountsPayableSepaPaymentPreviewSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name DownloadAccountsPayableSepaFile
   * @request POST:/api/v1/payment-details/accounts-payable/sepa/download
   */
  downloadAccountsPayableSepaFile = (
    data: DownloadSepaFileAccountsPayableWithIdsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/payment-details/accounts-payable/sepa/download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static downloadAccountsPayableSepaFilePath = '/v1/payment-details/accounts-payable/sepa/download'
  static downloadAccountsPayableSepaFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name RevokeFirstAuthorization
   * @request POST:/api/v1/payment-details/accounts-payable/revoke-first-authorization
   */
  revokeFirstAuthorization = (
    data: RevokeAuthorizationAccountsPayableRequestWithIds,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountsPayablePaymentDetailsDto[], any>({
      path: `/v1/payment-details/accounts-payable/revoke-first-authorization`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static revokeFirstAuthorizationPath =
    '/v1/payment-details/accounts-payable/revoke-first-authorization'
  static revokeFirstAuthorizationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name PreparePayment
   * @request POST:/api/v1/payment-details/accounts-payable/prepare/payment
   */
  preparePayment = (data: WalletPaymentsPrepareRequestWithIds, params: RequestParams = {}) =>
    this.http.request<BatchPreparePaymentsResponse, any>({
      path: `/v1/payment-details/accounts-payable/prepare/payment`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static preparePaymentPath = '/v1/payment-details/accounts-payable/prepare/payment'
  static preparePaymentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name DownloadPaymentOrderConfirmation
   * @request POST:/api/v1/payment-details/accounts-payable/payment-order-confirmation
   */
  downloadPaymentOrderConfirmation = (
    data: DownloadPaymentOrderConfirmationAccountsPayableRequestWithIdRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/payment-details/accounts-payable/payment-order-confirmation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static downloadPaymentOrderConfirmationPath =
    '/v1/payment-details/accounts-payable/payment-order-confirmation'
  static downloadPaymentOrderConfirmationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetPaymentExecutionDetails
   * @request POST:/api/v1/payment-details/accounts-payable/payment-execution-details
   */
  getPaymentExecutionDetails = (
    data: WalletPaymentExecutionDetailsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountsPayablePaymentExecutionDetailsDto[], any>({
      path: `/v1/payment-details/accounts-payable/payment-execution-details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPaymentExecutionDetailsPath =
    '/v1/payment-details/accounts-payable/payment-execution-details'
  static getPaymentExecutionDetailsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetPaged
   * @request POST:/api/v1/payment-details/accounts-payable/paged
   */
  getPaged = (data: AccountsPayablePaginationQuery, params: RequestParams = {}) =>
    this.http.request<PageAccountsPayablePaymentDetailsDto, any>({
      path: `/v1/payment-details/accounts-payable/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPagedPath = '/v1/payment-details/accounts-payable/paged'
  static getPagedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name MarkAsPaid
   * @request POST:/api/v1/payment-details/accounts-payable/mark-as-paid
   */
  markAsPaid = (data: MarkAsPaidAccountsPayableWithIdsRequest, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentDetailsDto[], any>({
      path: `/v1/payment-details/accounts-payable/mark-as-paid`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static markAsPaidPath = '/v1/payment-details/accounts-payable/mark-as-paid'
  static markAsPaidMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name MarkAsNotPaid
   * @request POST:/api/v1/payment-details/accounts-payable/mark-as-not-paid
   */
  markAsNotPaid = (data: MarkAsNotPaidAccountsPayableWithIdsRequest, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentDetailsDto[], any>({
      path: `/v1/payment-details/accounts-payable/mark-as-not-paid`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static markAsNotPaidPath = '/v1/payment-details/accounts-payable/mark-as-not-paid'
  static markAsNotPaidMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetCount
   * @request POST:/api/v1/payment-details/accounts-payable/count
   */
  getCount = (data: AccountsPayableCountRequest, params: RequestParams = {}) =>
    this.http.request<AccountsPayableCountResponse, any>({
      path: `/v1/payment-details/accounts-payable/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getCountPath = '/v1/payment-details/accounts-payable/count'
  static getCountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name Authorize
   * @request POST:/api/v1/payment-details/accounts-payable/authorise
   */
  authorize = (data: AuthoriseAccountsPayableWithIdsRequest, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentDetailsDto[], any>({
      path: `/v1/payment-details/accounts-payable/authorise`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static authorizePath = '/v1/payment-details/accounts-payable/authorise'
  static authorizeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetAll
   * @request POST:/api/v1/payment-details/accounts-payable/all
   */
  getAll = (data: AccountsPayableGetAllQuery, params: RequestParams = {}) =>
    this.http.request<GetAllAccountsPayableResponse, any>({
      path: `/v1/payment-details/accounts-payable/all`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAllPath = '/v1/payment-details/accounts-payable/all'
  static getAllMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name EditPaymentReference
   * @request PATCH:/api/v1/payment-details/accounts-payable/{id}/edit-payment-reference
   */
  editPaymentReference = (
    id: string,
    data: EditPaymentReferenceAccountsPayableWithNoIdentifierRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountsPayablePaymentDetailsDto, any>({
      path: `/v1/payment-details/accounts-payable/${id}/edit-payment-reference`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static editPaymentReferencePath =
    '/v1/payment-details/accounts-payable/${id}/edit-payment-reference'
  static editPaymentReferenceMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetById
   * @request GET:/api/v1/payment-details/accounts-payable/{id}
   */
  getById = (id: string, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentDetailsDto, any>({
      path: `/v1/payment-details/accounts-payable/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v1/payment-details/accounts-payable/${id}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetListByLinkedFlows
   * @request GET:/api/v1/payment-details/accounts-payable/list/by-linked-flow
   */
  getListByLinkedFlows = (query: GetListByLinkedFlowsParams, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentDetailsDto[], any>({
      path: `/v1/payment-details/accounts-payable/list/by-linked-flow`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getListByLinkedFlowsPath = '/v1/payment-details/accounts-payable/list/by-linked-flow'
  static getListByLinkedFlowsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetListByIds
   * @request GET:/api/v1/payment-details/accounts-payable/list/by-ids
   */
  getListByIds = (query: GetListByIdsParams, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentDetailsDto[], any>({
      path: `/v1/payment-details/accounts-payable/list/by-ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getListByIdsPath = '/v1/payment-details/accounts-payable/list/by-ids'
  static getListByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetInProgressAccountsPayableDetails
   * @request GET:/api/v1/payment-details/accounts-payable/in-progress-accounts-payable-details
   */
  getInProgressAccountsPayableDetails = (params: RequestParams = {}) =>
    this.http.request<InProgressAccountsPayableDetailsResponse, any>({
      path: `/v1/payment-details/accounts-payable/in-progress-accounts-payable-details`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInProgressAccountsPayableDetailsPath =
    '/v1/payment-details/accounts-payable/in-progress-accounts-payable-details'
  static getInProgressAccountsPayableDetailsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-details-controller
   * @name GetByLinkedFlow
   * @request GET:/api/v1/payment-details/accounts-payable/by-linked-flow
   */
  getByLinkedFlow = (query: GetByLinkedFlowParams, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentDetailsDto, any>({
      path: `/v1/payment-details/accounts-payable/by-linked-flow`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getByLinkedFlowPath = '/v1/payment-details/accounts-payable/by-linked-flow'
  static getByLinkedFlowMethod = 'GET'
}
